
/**
 * 获取传递参数信息
 */

  const getformData = (state) =>{
    const obj = {
      provincId : state.params.provincId,
      cityId : state.params.cityId,
      orgId : state.params.orgId,
      year : state.params.year
    }
    return obj
}


/**
 * 表格头过滤
 */
const tableQuery = (state) => state.columns.filter(item => item.isQuery);

/**
 * 表格头过滤
 */
const tableHeaderFileter = (state) =>state.columns.filter(item => item.isHeader);

/**
 * 表格表单配置
 */
const formConfig = (state) => state.columns.filter(item => item.isForm);

const getKeepLiveTags=(state)=>{
  console.log(state);
  return state.keepLiveTags
}



export default {
  getformData
};





















// WEBPACK FOOTER //
// ./src/store/getters.js